import { render } from "./IntegratedDeviceContainer.vue?vue&type=template&id=b8a43650&scoped=true"
import script from "./IntegratedDeviceContainer.vue?vue&type=script&lang=js"
export * from "./IntegratedDeviceContainer.vue?vue&type=script&lang=js"

import "./IntegratedDeviceContainer.vue?vue&type=style&index=0&id=b8a43650&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a43650"]])

export default __exports__